<!--
 * @Description: 检测数据
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-05 14:54:03
 -->

<template>
  <div class="detect_">
    <v-card class="mx-left left_" tile left_ width="300">
      <v-list
        :shaped="true"
        :avatar="true"
        :dense="true"
        :two-line="true"
        rounded
        style="display: inline-block;"
      >
        <v-list-item-group v-model="item_" color="primary">
          <v-list-item v-for="(it, i) in detect" :key="i" @click="info( it.id )">
            <v-list-item-avatar>
              <!-- <template v-slot:badge>
                  <span>{{ it.id }}</span>
              </template>-->
              <span v-if="it.type==0">{{ `NPT` }}</span>
              <span v-if="it.type==1">{{ `AVSS` }}</span>
              <!-- <img  style="height: 40px; width: 40px;border-radius: 50%;" :src="it.id" /> -->
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <span>检测时间： {{ it.create_time | time }}</span>
              </v-list-item-title>
              <v-list-item-subtitle
                class="brown--text darken-2"
              >检测时长：{{ formatSeconds( (it.end_time - it.start_time) ) }}</v-list-item-subtitle>
              <v-list-item-subtitle>平均力值：{{ it.ave_strength }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
    <div class="box_">
      <div class="total__">
        <div xs12 md3 id="myChart_" :style="{width: '99.5%', height: '20vh'}"></div>
      </div>
      <p>
          <v-btn color="primary" text icon value="justify_" @click="dataInfo">
            <v-icon>visibility</v-icon>
          </v-btn>
      </p>
      <div xs12 md3 id="myChart__" :style="{width: '99.5%', height: '46vh'}"></div>
    </div>
    <!-- 详情 -->
    <Module2 ref="module2"></Module2>
  </div>
</template>

<script>
import $echarts from "echarts";
import Module2 from "./module2.vue";
export default {
  name: "detect",
  components: {
    Module2
  },
  props: {
    detect: []
  },
  data() {
    return {
      item_: 0,
      dataList_: {
            ave_strength: 550,
            factors: "",
            list: [],
            state: true,
            user_name: "init_name"
      },
      data: [],
      // 区间数据
      erection: {
        A: 0,
        B: 90,
        C: 140,
        D: 190,
        E: 500,
        F: 550
      },
    };
  },
 mounted: function() {
   this.info(this.detect[0].id);
  },
  methods: {
      dataInfo(){
          this.$refs.module2.dialogShow(this.dataList_);
      },
    /* 获取年月日 */   
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      // var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
      // var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
      // var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());

      return Y + M + D;
    },
    /* 柱 */
    bar() {
      let myChart = $echarts.init(document.getElementById("myChart__"));
        myChart.setOption({
        title: {
          text: "",
          subtext: "时间颗粒度统计 数据来源：海恩思(深圳)信息科技有限公司" ,
          x: "center",
          top: 0
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            animation: false
          }
        },
        legend: {
          data: [],
          x: "left",
          left:  120
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: "none"
            },
            restore: {},
            saveAsImage: {},
            dataView: {
              default: "数据视图"
            }
          },
          right: 50
        },
        axisPointer: {
          link: { xAxisIndex: "all" }
        },
        dataZoom: [
          {
            show: true,
            realtime: true,
            start: 0,
            end: 100,
            xAxisIndex: [0, 1]
          },
          {
            type: "inside",
            realtime: true,
            start: 0,
            end: 100,
            xAxisIndex: [0, 1]
          }
        ],
        grid: [
          {
            left: 5,
            right: 5,
            top:  "0%",
            height: "0%"
          },
          {
            left: 140,
            right: 140,
            top:  "10%",
            height: "74%"
          }
        ],
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: { onZero: true },
            data: []
          },
          {
            gridIndex: 1,
            type: "category",
            boundaryGap: false,
            axisLine: { onZero: true },
            data: this.chartData("start_time"),
            position: "bottom"
          }
        ],
        yAxis: [
          {
            name: "硬度( g )",
            type: "value",
            max: 550
          },
          {
            gridIndex: 1,
            max: 550,
            name: "",
            type: "value"
            // inverse: true // 开始方向
          }
        ],
        series: 
          {
            name: "柱状图统计",
            type: "bar",
            maxWidth: 10,
            xAxisIndex: 1,
            yAxisIndex: 1,
            symbolSize: 8,
            hoverAnimation: false,
            data: this.chartData("strength"),
            itemStyle: {
              normal: {
                color: "#FFA726",
                barBorderRadius: 5
              }
            }
          }
        // ,
        // visualMap: 
        //   {
        //     seriesIndex: 1,
        //     show: true,
        //     type: "piecewise",
        //     min: 50,
        //     max: 550,
        //     inRange: {
        //       //定义 在选中范围中 的视觉元素
        //       color: ["#ff9649", "#d8bd28", "#3885e3", "#43af46", "#c23531"]
        //       // symbolSize: [100, 0]
        //     },
        //     bottom: 65,
        //     pieces: [
        //       { min: this.erection.E, label: "超人" },
        //       { min: this.erection.D, max: this.erection.E, label: "正常" },
        //       { min: this.erection.C, max: this.erection.D, label: "不充分" },
        //       { min: this.erection.B, max: this.erection.C, label: "无效" },
        //       { min: this.erection.A, max: this.erection.B, label: "未勃起" }
        //     ]
        //   }
        
      })
    },
    // 时间格式
    time(dataStr) {
      var time = new Date(dataStr * 1000);
      function timeAdd0(str) {
        if (str < 10) {
          str = "0" + str;
        }
        return str;
      }
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      return (
        y +
        "-" +
        timeAdd0(m) +
        "-" +
        timeAdd0(d) +
        " " +
        timeAdd0(h) +
        ":" +
        timeAdd0(mm) +
        ":" +
        timeAdd0(s)
      );
    },
    /* 整理数据 */

    chartData(key) {
      let list = [];
      if (key == "start_time") {
        this.data.forEach(item => {
          list.push(this.time(item[key]));
        });
      } else {
        this.data.forEach(item => {
          list.push(item[key]);
        });
        // this.max_strength = Math.max(...list);
      }
      return list;
    },
    // 线柱统计图
    drawLine() {
      let myChart = $echarts.init(document.getElementById("myChart_"));
      window.console.log(this.detect);
      let data = [];
      this.detect.forEach(item => {
        let list = [];
        list[0] = this.timestampToTime(item.create_time * 1000);
        list[1] = item.ave_strength;
        data.unshift(list);
      });

      let dateList = data.map(function(item) {
        return item[0];
      });
      let valueList = data.map(function(item) {
        return item[1];
      });
      myChart.setOption({
        // Make gradient line here
        visualMap: [
          {
            show: false,
            type: "continuous",
            seriesIndex: 0,
            min: 0,
            max: 550
          }
        ],
        title: [
          {
            left: "center",
            text: "*近一年勃起趋势图"
          }
        ],
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          data: dateList
        },
        yAxis: {
          splitLine: { show: false },
          name: "硬度( g )",
          type: "value",
          max: 550
        },
        grid: [
          {
            bottom: "10%"
          },
          {
            top: "10%"
          }
        ],
        series: [
          {
            type: "line",
            showSymbol: false,
            data: valueList
          }
        ]
      });
    },
    // 详情
    info(id) {
      // inspection_ed_record_list
      this.$axios({
        method: "get",
        url: `${this.$apis.URL.inspection_ed_record_list}?id=${id}`,
        data: {}
      })
        .then(req => {
          if (req.data.result == 0) {
            this.dataList_.list = req.data.datas;
            let data = req.data.datas;
            // if( start ){
            //     let dataList = {list: data};
            //     this.$refs.module2.dialogShow(dataList);
            // }else{
            window.console.log(data);
            let index = 0;
            /* 
              按时间线缺省补零
              没有值的时候间隔1分钟补零
             */ 
            let starting_time = data[0].start_time;
            let end_time = data[data.length - 1].start_time;
            let list_ = {};
            data.forEach(element => {
              list_[`${element.start_time}`] = element.strength;
            });
            let list = [];
            for (let time = starting_time; time <= end_time; time += 5) {
              if (`${time}` in list_) {
                list.push({
                  start_time: time,
                  strength: list_[`${time}`]
                });
                index = 0;
              } else {
                index++;
                if( index >= 12 ){
                    list.push({
                        start_time: time,
                        strength: 0
                    });
                    index = 0;
                }
              }
            }
            this.data = list;

            window.console.log(this.chartData("start_time"));
            this.drawLine();
            this.bar();
            



          } else {
            this.$Dialog.getProductCheckResult_({
              text: req.data.message,
              timeout: 3000,
              snackbar: true
            });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({
            text: error,
            timeout: 3000,
            snackbar: true
          });
        });
    },
    // 秒转换时分秒
    formatSeconds(value) {
      let time = value;
      let min = Math.floor(time % 3600);
      return (
        (Math.floor(time / 3600) < 10
          ? `0${Math.floor(time / 3600)}`
          : Math.floor(time / 3600)) +
        ":" +
        (Math.floor(min / 60) < 10
          ? `0${Math.floor(min / 60)}`
          : Math.floor(min / 60)) +
        ":" +
        (time % 60 < 10 ? `0${time % 60}` : time % 60)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.detect_ {
  width: 100%;
  > .left_,
  > .box_ {
    display: inline-block;
    height: calc(100vh - 255px);
    overflow-y: auto;
    overflow-x: hidden;
  }
}
.box_ {
//   border: solid 1px #000;
  height: calc(100vh - 200px);
  width: calc(100vw - 400px);
  margin-left: 10px;
  float: right;
}

.total__ {
//   border: solid 1px #000;
  width: 100%;
  height: 200px;
}

.left_::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px;
  /*高宽分别对应横竖滚动条的尺寸*/
  background: #ebeef5;
  -webkit-box-shadow: inset 1px 0 1px rgba(0, 0, 0, 0.2);
}

.left_::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.6);
  height: 120px;
}

.left_::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.1);
}

.left_::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px;
  /*高宽分别对应横竖滚动条的尺寸*/
  background: #ebeef5;
  -webkit-box-shadow: inset 1px 0 1px rgba(0, 0, 0, 0.2);
}

.left_::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.2);
  height: 120px;
}

.left_::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
  border-radius: 2px;
  background: #fff;
}
</style>